import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/lib/supabase';

export interface BillingAddress {
  line1: string | null;
  city: string | null;
  state: string | null;
  postal: string | null;
  billingEmail: string | null;
  billingContactName: string | null;
}

interface DbRow {
  line1: string | null;
  city: string | null;
  state: string | null;
  postal: string | null;
  billing_email: string | null;
  billing_contact_name: string | null;
}

/**
 * Billing address for the active customer — joins orders.customers (which
 * carries billing_email + contact name) with ops.qbo_customers (street /
 * city / state / postal). Returns null when no row exists for the caller
 * (unlikely but defensive).
 */
export function useBillingAddress() {
  return useQuery<BillingAddress | null>({
    queryKey: ['billing-address'],
    queryFn: async () => {
      const { data, error } = await supabase
        .schema('orders')
        .from('v_my_billing_address')
        .select('line1, city, state, postal, billing_email, billing_contact_name')
        .maybeSingle();
      if (error || !data) return null;
      const row = data as DbRow;
      return {
        line1: row.line1,
        city: row.city,
        state: row.state,
        postal: row.postal,
        billingEmail: row.billing_email,
        billingContactName: row.billing_contact_name,
      };
    },
    staleTime: 60 * 1000,
  });
}
